import findResult, { findWithCodes } from '@/utils/resultsHelper';
import { datasetCategories } from '../constants';

export const findAllDatasetsByMetadata = ({ datasets }, { items }) => {
  const codes = items.map(({ metadata }) => metadata.dataset_code);
  return { codes, categories: findWithCodes(datasets, datasetCategories, codes) };
};

export const findDatasets = ({ datasets }, { category }) => datasets[category];

export const findAllDatasets = ({ datasets }, { items }) => {
  const codes = items.map(({ code }) => code);
  return findWithCodes(datasets, datasetCategories, codes);
};

const findDataset = ({ datasets }, { category, code }) => (
  findResult(datasets, category, code)
);

export default findDataset;
